import { RemainOnBoardUnitUpsertedDto } from '@planning/app/api'
import restowService from '@planning/services/restowService'
import { debounce } from 'lodash'
import { action, computed, makeObservable, observable, runInAction } from 'mobx'
import { VesselTallyViewStore } from './VesselTallyViewStore'

export class SearchRobViewStore {
  selectedRobId?: number
  searchFilter = ''
  robUnits: RemainOnBoardUnitUpsertedDto[] = []
  loading = false

  constructor(public parentStore: VesselTallyViewStore) {
    makeObservable(this, {
      robUnits: observable,
      searchFilter: observable,
      loading: observable,
      setSearchFilter: action,
      setLoading: action,
      removeRobUnitFromListById: action,
      isSearchFilterValid: computed,
    })
  }

  private debouncedFetchRobUnits = debounce(async (filter: string) => {
    const robUnits = await restowService.get(this.parentStore.selectedVisitId, filter, true)
    runInAction(() => {
      this.robUnits = robUnits
      this.loading = false
    })
  }, 500)

  get isSearchFilterValid() {
    return this.searchFilter.length >= 5
  }

  setSearchFilter = (filter: string) => {
    this.searchFilter = filter.toUpperCase()
    this.loading = true
    if (filter.length >= 5) {
      this.debouncedFetchRobUnits(this.searchFilter)
    } else {
      runInAction(() => {
        this.robUnits = []
        this.loading = false
      })
    }
  }

  removeRobUnitFromListById = (id: number) => {
    this.robUnits = this.robUnits.filter(rob => rob.id !== id)
  }

  setLoading = (loading: boolean) => {
    this.loading = loading
  }

  createRestowFromRob = async (robId: number) => {
    return await restowService.createRestowFromRob(robId)
  }
}
